import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import IconButton from '@material-ui/core/IconButton';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import Typography from '@material-ui/core/Typography';

import {Auth} from 'aws-amplify';
import {API} from 'aws-amplify';
import Deals from './dashboard/Deals';
import ReactGA from 'react-ga';


const styles = theme => ({
  button: {
    //margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  detailHeader: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    //paddingLeft: '5px',
    //paddingTop: '5px',
  },
  contrastText: {
    color: theme.palette.primary.contrastText,
  },
});

class FavoriteDeals extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cognitoUser: '',
      favoriteDeals: []
    };
  }

  componentWillMount() {
    this.getCognitoUserSession();

    ReactGA.initialize('UA-107081605-2');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

  }

  //get the logged-in user session
  getCognitoUserSession = async () => {
    //console.log('now in getCognitoUserSession()');
    try {
      Auth.currentAuthenticatedUser()
        .then(data => {
          //console.log(data);
          this.setState({
              cognitoUser: data,
          });
          this.getFavoriteDeals(data);
        })
    } catch (err) {
      console.log('error fetching user info: ', err);
    }
  }

  getFavoriteDeals = (data) => {
    //console.log('now in getFavoriteDeals()');
    //const { favoriteDeals } = this.state;
    let requestParams = {
        headers: {'content-type': 'application/json'},
        body : {
            'favoriteDeals': data.attributes['custom:favoriteDeals'].split(",")
        }
    }

    API.post('leasy','/get-favorite-deals', requestParams)
        .then(data => {
          //console.log(data);
          this.setState({
              favoriteDeals: data
          });
          return data;
        })
        .catch (err => console.log(err))
  }

  handleBackClick = () => {
    //console.log('back clicked');
    this.props.history.goBack()
  }
  /*
  insertFavDeals = () => {
    console.log('in insertFavDeals');
    let _deals = "a98ccc63-36ca-40bd-a544-2a5c112e2f1b,4e9d6202-126e-4560-a5b3-a53051ee4a89";
    try {
      Auth.updateUserAttributes(this.state.cognitoUser, {
          "custom:favoriteDeals": _deals
      });
    } catch (err) {
      console.log('error updating user info: ', err);
    }
  }
  */

  render() {
    const { classes } = this.props;
    const { favoriteDeals } = this.state;

    return (
      <div>

            <Paper className={classes.detailHeader}>
              <IconButton className={classes.contrastText} aria-label="Menu" onClick={this.handleBackClick}>
                <NavigateBeforeIcon />
              </IconButton>

              <Typography className={classes.contrastText}  variant="subheading" color="inherit">
                FAVORITE DEALS
              </Typography>
            </Paper>
            { favoriteDeals && <Deals list={favoriteDeals}/> }
      </div>
    );
  }

}

FavoriteDeals.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FavoriteDeals);



// WEBPACK FOOTER //
// ./src/components/FavoriteDeals.jsx